import {Component, OnInit} from '@angular/core';
import {DialogModule} from 'primeng/primeng';
import {DataTableModule} from 'primeng/primeng';

@Component({
    selector: 'app-mourtury',
    templateUrl: './mourtury.component.html',
    styleUrls: ['./mourtury.component.css'],

})
export class MourturyComponent implements OnInit {
    display: Boolean = false;
    display1: Boolean = false;
    display3: Boolean = false;
    display4: Boolean = false;
    display5: Boolean = false;
    display6: Boolean = false;
    display7: Boolean = false;
    cols: any[];

    constructor(private dialogModule: DialogModule, private datatable: DataTableModule) {
    }

    ngOnInit() {
        this.cols = [
            {field: 'vin', header: 'Vin'},
            {field: 'year', header: 'Year'},
            {field: 'brand', header: 'Brand'},
            {field: 'color', header: 'Color'}
        ];
    }

//     showCar(car: Car) {
//         this.selectedCar = car;
//         this.dialogVisible = true;
//     }
// }
//
//
    onViewSelect() {
        this.display3 = true;
    }

    showDialog() {
        this.display = true;
    }

    showModel() {
        this.display1 = true;
    }

    onViewSelect1() {
        this.display3 = true;
    }

    onViewSelect2() {
        this.display4= true;
    }

    onViewSelect3() {
        this.display5 = true;
    }


    onViewSelect4() {
        this.display6 = true;
    }

    onViewSelect5() {
        this.display7 = true;
    }
}


// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mourtury/mourtury.component.ts